import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FontSizePreferenceService } from './shared/components/font-size-selector/font-size-selector.service';
import { retrieveUrlQueryParams } from './shared/helpers/retrive-url-query-params';
import { LanguageService } from './shared/language/language.service';
import { SubDivision } from './shared/sub-division/sub-division.model';
import { SubDivisionService } from './shared/sub-division/sub-division.service';
import { User } from './shared/user/user.model';
import { UserService } from './shared/user/user.service';

@Component({
  selector: 'wings-root',
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class App implements OnInit {
  private readonly fontSizePreferenceService = inject(FontSizePreferenceService);
  private readonly languageService = inject(LanguageService);
  private readonly subDivisionService = inject(SubDivisionService);
  private readonly userService = inject(UserService);

  url = location.href;

  ngOnInit() {
    this.fontSizePreferenceService.initialize();

    const { subDivision, language, userInfo } = retrieveUrlQueryParams(this.url);
    this.languageService.setLanguage(language);
    this.subDivisionService.setSubDivision(subDivision as SubDivision);
    this.setUserIfExists(userInfo);
  }

  private setUserIfExists(userInfo: string) {
    if (userInfo) {
      const user = this.createUserByUrlInfos(userInfo);
      this.userService.setUser(user);
    }
  }

  private createUserByUrlInfos(userInfo: string) {
    return User.fromJSON(JSON.parse(userInfo) as object);
  }
}
